import { createReducer, on } from '@ngrx/store';

import * as RootActions from '../root-store/root.actions';
import { ExtensaAuthState } from './types';

export interface ConnectivityState {
    extensa: {
        isConnected: boolean;
        auth: ExtensaAuthState | null;
    };
    isIntegration: {
        isConnected: boolean;
    };
    signalr: {
        isConnected: boolean;
    };
    viewer: {
        isConnected: boolean;
    };
}

export const connectivityInitialState: ConnectivityState = {
    extensa: {
        isConnected: false,
        auth: null,
    },
    isIntegration: {
        isConnected: false,
    },
    signalr: {
        isConnected: false,
    },
    viewer: {
        isConnected: false,
    },
};

export const connectivityReducer = createReducer(
    connectivityInitialState,
    on(RootActions.seExtensaConnected, (state, { isConnected }) => {
        return {
            ...state,
            extensa: {
                ...state.extensa,
                isConnected,
            },
            viewer: {
                isConnected,
            },
        };
    }),
    on(RootActions.seExtensaAuth, (state, { accessToken, expiresIn, refreshToken }) => {
        return {
            ...state,
            extensa: {
                ...state.extensa,
                auth: {
                    accessToken,
                    expiresIn,
                    refreshToken,
                },
            },
        };
    }),
    on(RootActions.seIsIntegrationAppConnected, (state, { isConnected }) => {
        return {
            ...state,
            isIntegration: {
                isConnected,
            },
        };
    }),
    on(RootActions.seSignalrConnected, (state, { isConnected }) => {
        return {
            ...state,
            signalr: {
                isConnected,
            },
        };
    }),
    on(RootActions.seViewerConnected, (state, { isConnected }) => {
        return {
            ...state,
            viewer: {
                isConnected,
            },
        };
    }),
);
